module.exports = __webpack_public_path__ + "img/catavasier-1742-pagina-de-titlu-big.db663c1a.jpg";